export default function downloadFile(blob, { name = 'file' }) {
  const url = window.URL.createObjectURL(blob, { type: 'octet/stream' });
  const a = document.createElement('a');
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
}
